import { lazy, Suspense } from "react";
import PayperviewPickedout from "components/skeleton/PayperviewPickedout";

const PurchesedCoursel = lazy(() => import("./PurchesedCoursel"));

function Purchased({ purchased, isLoading, user }: any) {
  return (
    <div>
      {purchased?.length === 0 ? (
        <></>
      ) : (
        <>
          {!isLoading && (
            <Suspense fallback={<PayperviewPickedout />}>
              <PurchesedCoursel events={purchased} user={user} />
            </Suspense>
          )}
          {isLoading && <PayperviewPickedout />}
        </>
      )}
    </div>
  );
}
export default Purchased;
